import React from 'react';
import { AText, Box } from '@alf/uikit';
import { useI18n } from '@namespace/i18n';
import { WheelSegment } from '../../types';

import styles from './index.module.css';

export const defaultSegments: WheelSegment[] = [
  { id: 1, value: '', type: 'empty' },
  { id: 2, value: '', type: 'empty' },
  { id: 3, value: '', type: 'empty' },
  { id: 4, value: '', type: 'empty' },
  { id: 5, value: '', type: 'empty' },
  { id: 6, value: '', type: 'empty' },
  { id: 7, value: '', type: 'empty' },
  { id: 8, value: '', type: 'empty' }
];

export const segmentsTypes = {
  empty: 'empty',
  pwb: 'pwb',
  ads: 'ads'
} as const;

const ADSContent = ({ value }: { value: WheelSegment['value'] }) => {
  const { t } = useI18n();

  return (
    <Box className={styles.segmentContent}>
      <AText component="p" className={styles.segmentTitle}>
        {value || ' '}
      </AText>
      <AText
        transform="uppercase"
        className={`${styles.ADStitle} ${styles.segmentInfo}`}
      >
        {t('web.wheel.segment.ads.title')}
      </AText>
      <AText
        transform="uppercase"
        color="txt_color_1"
        className={`${styles.ADSsubtitle} ${styles.segmentInfo}`}
      >
        {t('web.wheel.segment.ads.subtitle')}
      </AText>
    </Box>
  );
};

const PWBContent = ({ value }: { value: WheelSegment['value'] }) => {
  const { t } = useI18n();

  return (
    <Box className={styles.segmentContent}>
      <AText component="p" className={styles.segmentTitle}>
        {value || ' '}%
      </AText>
      <AText transform="uppercase" className={styles.segmentInfo}>
        {t('web.wheel.segment.pwb.title')}
      </AText>
    </Box>
  );
};

const EmptyContent = () => {
  const { t } = useI18n();
  return (
    <Box className={styles.segmentContent}>
      <AText component="p" className={styles.segmentTitle}>
        {t('web.wheel.segment.empty.title')}
      </AText>
      <AText transform="uppercase" className={styles.segmentInfo}>
        {t('web.wheel.segment.empty.subtitle')}
      </AText>
    </Box>
  );
};

export const segmentContentMap = {
  [segmentsTypes.ads]: ADSContent,
  [segmentsTypes.pwb]: PWBContent,
  [segmentsTypes.empty]: EmptyContent
};
